import { ModalManager } from '@ncr-retail/base-retail-components';
import React, { createContext, useState } from 'react';
import HomePageLayout from 'src/home-page/components/home-page-layout';
import Initialize from 'src/initialize/components/initialize';
import LoginWrapper from 'src/login/components/login-wrapper';
import TouchPointRegistration from 'src/touchpoint/components/touchpoint-registration';
import TouchPointStart from 'src/touchpoint/components/touchpoint-start';

export enum XLRStartSequenceState {
  Initialize = 'Initialize',
  Setup = 'Setup',
  Login = 'Login',
  PostLogin = 'PostLogin',
  Runtime = 'Runtime',
}

// context created to project pos service type through app scope
export const RedirectContext = createContext<IRedirectContext>({ setStartupState: () => {} });

export const XLRStartupSequence: React.FC = () => {
  const startupConfig: {
    [key in XLRStartSequenceState]: JSX.Element;
  } = {
    Initialize: <TouchPointStart />,
    Setup: <TouchPointRegistration />,
    Login: <LoginWrapper />,
    PostLogin: <Initialize />,
    Runtime: <HomePageLayout />,
  };

  const [state, setStartupState] = useState<XLRStartSequenceState>(
    XLRStartSequenceState.Initialize,
  );

  return (
    <RedirectContext.Provider value={{ setStartupState }}>
      {startupConfig[state]}
      <ModalManager />
    </RedirectContext.Provider>
  );
};

export interface XLRStartupProps {
  setStartupState: (newState: XLRStartSequenceState) => void;
}

export interface IRedirectContext {
  setStartupState: (newState: XLRStartSequenceState) => void;
}
